function isProxy(obj) {
  const uniqueSymbol = Symbol("someuniquekey");
  return obj[uniqueSymbol] === uniqueSymbol;
}

export function merge(original = {}, mixin = {}) {
  // make a copy to avoid mutations of nested objects

  // in jest we're using module mappper for css
  if (process.env.NODE_ENV !== "production") {
    if (isProxy(original)) {
      return original;
    }
    if (isProxy(mixin)) {
      return mixin;
    }
  }

  const result = { ...original };

  // traverse mixin keys and merge them to resulting theme
  Object.keys(mixin).forEach(key => {
    const originalValue = original[key];
    const mixinValue = mixin[key];

    if (typeof originalValue === "function" || typeof mixinValue === "function") {
      // this handles issue when isomorphic-style-loader addes helper functions to css-module
      return;
    }

    if (mixinValue === undefined) {
      return;
    }

    if (originalValue === undefined) {
      // mixin key is new to original theme - take it as is
      result[key] = mixinValue;
      return;
    }

    if (typeof mixinValue === "object" && typeof originalValue === "object") {
      // exactly nested theme object - go recursive
      result[key] = merge(originalValue, mixinValue);
      return;
    }
    if (typeof mixinValue === "object" || typeof originalValue === "object") {
      // can't merge a non-object with an object
      throw new Error(
        `You are merging non-object with object, original: ${originalValue}, mixin: ${mixinValue}, key: ${key}`
      );
    }

    // finally we can merge
    result[key] = originalValue
      .split(" ")
      .concat(mixinValue.split(" "))
      .filter((item, pos, self) => self.indexOf(item) === pos && item !== "")
      .join(" ");
  });

  return result;
}

export function themeable(...themes) {
  return themes.reduce((acc, theme) => merge(acc, theme), {});
}
